import * as angular from 'angular';

import { ComponentDefinition, ContextualField, PropertyType, KeyValuePair } from '../../../models/index';
import * as Fields from '../../../common/helpers/contextual';
import { GroupStatesConfiguration } from '../groupStates.configuration';

class GroupStatesContextualController implements angular.IComponentController {
    configuration: GroupStatesConfiguration;
    formController: angular.IFormController;
    isLoading: boolean;
    loadingMessage: string;
    properties: ContextualField[];
    modes: KeyValuePair<number | undefined, string>[] = [
        //{ key: undefined, value: '' },
        { key: 0, value: 'Frequency' },
        { key: 1, value: 'Timeline' }
    ];

    save: () => void;
    cancel: () => void;

    static $inject = ['$q'];

    constructor(private _$q: angular.IQService) {
    }

    $onInit() {
        this.initProperties();
    }

    private initProperties() {
        if(this.configuration.alignedOn === undefined){
            this.configuration.alignedOn = 0;
        }
        const properties: ContextualField[] = [
            {
                modelName: 'mode',
                propertyType: PropertyType.Select,
                label: 'Mode',
                placeholder: 'Mode',
                propertyName: 'modeProperty',
                iconText: 'Mode',
                extraData: {
                    options: this.modes,
                    sortAlpha: true,
                    sortAscending: true
                }
            },
            angular.copy(Fields.IsLegendVisible),
            angular.copy(Fields.MinPeriod),
            angular.copy(Fields.MaxPeriod),
            angular.copy(Fields.PeriodReference),
            // angular.copy(Fields.IsEndDateIncluded)
        ];
        this.properties = properties;
    }

    onSave(): any {
        return this._$q.when(this.save());
    }

    onCancel() {
        this.cancel();
    }
}

export const wtGroupStatesContextual: ComponentDefinition = {
    componentId: 'wtGroupStatesContextual',
    controller: GroupStatesContextualController,
    template: require('./groupStatesContextual.component.html'),
    controllerAs: 'vm',
    bindings: {
        formController: '=',
        configuration: '=',
        save: '&?',
        cancel: '&?'
    }
};
